"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackGiftScheduled = exports.useTrackGiftScheduleClicked = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _services = require("@alycecom/services");

var _reactRedux = require("react-redux");

var _auth = require("../../../Auth/store/auth.selectors");

var _useGiftContext2 = require("../../hooks/useGiftContext");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useGiftSchedulePayload = function useGiftSchedulePayload() {
  var adminId = (0, _reactRedux.useSelector)(_auth.getLoginAsAdminId);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      _useGiftContext$user = _useGiftContext.user,
      orgId = _useGiftContext$user.orgId,
      orgName = _useGiftContext$user.orgName;

  return (0, _react.useMemo)(function () {
    return [{
      adminId
    }, {
      groupId: orgId,
      traits: {
        adminId,
        orgName,
        orgId
      }
    }];
  }, [adminId, orgId, orgName]);
};

var useTrackGiftScheduleClicked = function useTrackGiftScheduleClicked() {
  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var _useGiftSchedulePaylo = useGiftSchedulePayload(),
      _useGiftSchedulePaylo2 = (0, _slicedToArray2.default)(_useGiftSchedulePaylo, 2),
      payload = _useGiftSchedulePaylo2[0],
      options = _useGiftSchedulePaylo2[1];

  return (0, _react.useCallback)(function () {
    trackEvent('Schedule feature — clicked', payload, options);
  }, [trackEvent, payload, options]);
};

exports.useTrackGiftScheduleClicked = useTrackGiftScheduleClicked;

var useTrackGiftScheduled = function useTrackGiftScheduled() {
  var _TrackEvent$useTrackE2 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE2.trackEvent;

  var _useGiftSchedulePaylo3 = useGiftSchedulePayload(),
      _useGiftSchedulePaylo4 = (0, _slicedToArray2.default)(_useGiftSchedulePaylo3, 2),
      payload = _useGiftSchedulePaylo4[0],
      options = _useGiftSchedulePaylo4[1];

  return (0, _react.useCallback)(function (preset, scheduleAt) {
    trackEvent('Gift invitation — scheduled', _objectSpread(_objectSpread({}, payload), {}, {
      preset,
      scheduleAt: scheduleAt && scheduleAt.tz('US/Eastern').format('DD/MM/YYYY HH:mm')
    }), options);
  }, [trackEvent, payload, options]);
};

exports.useTrackGiftScheduled = useTrackGiftScheduled;